import {
  CentraApiResult,
  CentraCheckoutApiProduct,
  CentraErrorsResponse,
  CentraGetProductsPayload,
  CentraGetProductsResponse,
  CentraTokenHandler,
} from "@made-people/centra-checkout-api";
import { BffClient } from "@made-people/gears-bff-client";
import {
  CentraProductsResponseV1,
  FrontendContextV1,
} from "@made-people/nestjs-bff-service";
import { frontendProductToCheckoutApiProduct } from "./mappers/frontend-product-to-checkout-api-product";

export const bffCheckoutApiGetProducts = async (
  payload: CentraGetProductsPayload,
  bffClient: BffClient,
  centraTokenHandler: CentraTokenHandler,
  frontendContext: FrontendContextV1,
): Promise<
  CentraApiResult<CentraGetProductsResponse, CentraErrorsResponse>
> => {
  const emptyResult = {
    success: {
      products: [],
      filter: [],
      productCount: 0,
      token: centraTokenHandler.getToken() ?? "",
    },
    error: null,
  };
  let result: CentraProductsResponseV1 | undefined;
  try {
    if (payload.products?.length) {
      result = await bffClient.fetchFrontendProductsCached(
        payload.products!,
        frontendContext,
      );
    } else {
      result = await bffClient.fetchFrontendProducts({
        frontendContext,
        payload,
      });
    }
  } catch (error) {
    console.error(error);
    return emptyResult;
  }

  if (!result) {
    return emptyResult;
  }

  return {
    success: {
      products: result.frontendProducts.map(
        (product) =>
          frontendProductToCheckoutApiProduct(
            product,
          ) as unknown as CentraCheckoutApiProduct,
      ),
      filter: [],
      productCount: result.productCount,
      token: centraTokenHandler.getToken() ?? "",
    },
    error: null,
  };
};
